import React from 'react';
import ManageCompanyBankForm from '../Forms/manage_company_bank_form';
import { ManageDataPage } from './manageDataShared';

const COLUMNS = [
    { label: 'Name', field: 'Name' },
    { label: 'Address', field: 'Address' },
    { label: 'Account No.', field: 'AccountNo' },
    { label: 'Swift Code', field: 'SwiftCode' },
];

function Manage_company_bank() {
    return (
        <ManageDataPage
            title="Manage Company Bank"
            endpoint="get_manage_company_bank_table"
            columns={COLUMNS}
            idKey="CompanyBankID"
            FormComponent={ManageCompanyBankForm}
            searchPlaceholder="Search bank, account, swift..."
        />
    );
}

export default Manage_company_bank;
